import React from "react";
import { Tooltip } from "@mui/material";

const PoonaWallaTooltip = ({ title, children, ...rest }) => {
  return (
    <>
      <Tooltip title={title} arrow {...rest}>
        {children}
      </Tooltip>
    </>
  );
};

export default PoonaWallaTooltip;
